export default {"src":"/_next/static/media/logo.aae08a8f.svg","height":113,"width":1123};